import dynamic from 'next/dynamic';
import { SearchModuleProps } from './search-module';
import { CombinedSearchModuleProps } from './combined-search/combined-search-module';

export const SearchModule = dynamic<SearchModuleProps>(() => import('./search-module').then((mod) => mod.SearchModule));
export const CombinedSearchModule = dynamic<CombinedSearchModuleProps>(() =>
    import('./combined-search/combined-search-module').then((mod) => mod.CombinedSearchModule)
);
